import { formatDimension, formatQuantityValue, parseFloatValue } from "../../../../helpers/unitOfMeasurementHelpers";

const getFirstLocationId = (mills = []) => {
  const [firstMill = {}] = mills;
  const { location = {} } = firstMill;
  return location.locationId || "";
};

export const searchColumns = [
  { keyName: "customerPOId" },
  { keyName: "soldTo.customerName" },
  { keyName: "shipTo.customerName" },
  { keyName: "mills", formatRowData: getFirstLocationId },
  { keyName: "endUserId" },
  { keyName: "pricingPeriodDate" },
  { keyName: "quantityAcknowledged", formatRowData: formatQuantityValue },
  { keyName: "quantityShipped", formatRowData: formatQuantityValue },
  { keyName: "quantityRemaining", formatRowData: formatQuantityValue }
];

export const sortColumns = [
  { keyName: "customerPOId" },
  { keyName: "soldTo.customerName" },
  { keyName: "shipTo.customerName" },
  { keyName: "mills", formatRowData: getFirstLocationId },
  { keyName: "endUserId" },
  { keyName: "pricingPeriodDate" },
  { keyName: "quantityAcknowledged.value", formatRowData: parseFloatValue },
  { keyName: "quantityShipped.value", formatRowData: parseFloatValue },
  { keyName: "quantityRemaining.value", formatRowData: parseFloatValue }
];

export const prePlanningSearchColumns = [
  { keyName: "customerPOId" },
  { keyName: "endUserId" },
  { keyName: "orderedProduct.productName" },
  { keyName: "orderedProduct.dimension", formatRowData: formatDimension },
  { keyName: "mill.millId" },
  { keyName: "modeOfTransport" },
  { keyName: "orderedProduct.quantityAcknowledged.value", formatRowData: parseFloatValue },
  { keyName: "deliveryDate" },
  { keyName: "pressDate" }
];

export const prePlanningSortColumns = [
  { keyName: "customerPOId" },
  { keyName: "endUserId" },
  { keyName: "orderedProduct.productName" },
  { keyName: "orderedProduct.dimension", formatRowData: formatDimension },
  { keyName: "mill.millId" },
  { keyName: "modeOfTransport" },
  { keyName: "orderedProduct.quantityAcknowledged.value", formatRowData: parseFloatValue },
  { keyName: "deliveryDate" },
  { keyName: "pressDate" },
  { keyName: "deliveryDays", formatRowData: parseFloatValue }
];



// WEBPACK FOOTER //
// ./src/components/PurchaseOrder/ListPage/List/SearchColumns.js